import { CreditCardIcon } from "@heroicons/react/24/outline";
import { router } from "@inertiajs/react";
import Layout from "@/components/Layout";
import BenefitsExplanation from "@/components/subscriptions/BenefitsExplanation";
import PricingTable from "@/components/subscriptions/PricingTable";
import UsageStats from "@/components/subscriptions/UsageStats";
import type { CurrentSubscription, SubscriptionPricing, SubscriptionUsage } from "@/types";

type ShowProps = {
  pricing: SubscriptionPricing;
  subscription: CurrentSubscription;
  usage: SubscriptionUsage;
};

export default function Show({ pricing, subscription, usage }: ShowProps) {
  return (
    <Layout title="Subscription">
      <div className="mb-6">
        <h1 className="mb-1 text-2xl font-semibold">Subscription</h1>
        <p className="text-gray-500">See remaining page audits, refresh timing, and domain capacity for your plan.</p>
      </div>

      {subscription?.customer_portal_available ? (
        <section className="card mb-6">
          <div className="card-body">
            <h2 className="mb-4 text-lg font-semibold">Subscription Status</h2>
            <div className="flex items-center">
              <div className="mr-4 flex h-12 w-12 items-center justify-center rounded-full bg-success-light">
                <CreditCardIcon className="h-8 w-8 text-success" aria-hidden="true" />
              </div>
              <div>
                <p className="text-lg font-medium">Active Subscription</p>
                <p className="text-gray-600">Your subscription is active and will renew automatically.</p>
              </div>
            </div>

            <div className="mt-6">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => router.post("/subscription/customer-portal")}
              >
                <CreditCardIcon className="h-5 w-5" aria-hidden="true" /> Manage Subscription
              </button>
            </div>
          </div>
        </section>
      ) : null}

      <div className="mb-6 grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(320px,420px)]">
        <UsageStats subscription={subscription} usage={usage} />
        <BenefitsExplanation />
      </div>

      <section className="card">
        <div className="card-body">
          <PricingTable pricing={pricing} currentPlan={usage.plan} />
        </div>
      </section>
    </Layout>
  );
}
